import script from "./Userlog.vue?vue&type=script&setup=true&lang=js"
export * from "./Userlog.vue?vue&type=script&setup=true&lang=js"

import "./Userlog.vue?vue&type=style&index=0&id=50b8e636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b8e636"]])

export default __exports__